<button [attr.id]="'Open' + inputId" [ngClass]="!options.buttonClass ? 'btn btn-info' : options.buttonClass" *ngIf="chosenOffer == null" data-toggle="modal" [attr.data-target]="'#searchOfferModal' + inputId" (click)="isSearching = true;search()" title="{{ options.customButtonText == null ? ('Offers.Search' | translate) + ' ' + (('Standard.Offer' | translate ) | lowercase) : ( options.customButtonText | translate) }}">
  <i class="fas fa-file-edit" *ngIf="addFrom"></i> 
  {{ !addFrom ? (options.customButtonText == null ? ('Offers.Search' | translate) + ' ' + (('Standard.Offer' | translate ) | lowercase) : ( options.customButtonText | translate)) :'' }}
</button>
<button [ngClass]="options.buttonClass == null ? 'btn btn-info' : options.buttonClass" *ngIf="!!chosenOffer && !options.hideOpener" (click)="chosenOffer = null;chosen.emit(null)">
  <div class="d-flex flex-column">
    <b *ngIf="!!chosenOffer.customer">{{ chosenOffer.customer.name }}</b>
    <b *ngIf="!!chosenOffer.customer">{{ chosenOffer.customer.address }}</b>
  </div>
  <div>{{ chosenOffer.zipCode}} {{ chosenOffer.city}}</div>
</button>

<div class="modal" [attr.id]="'searchOfferModal' + inputId" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Offers.Search' | translate }} {{ ('Standard.Documents' | translate ) | lowercase }}</h5>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="isSearching">
        <div class="row">
          <div class="col-6 d-flex">
            <input class="form-control" type="text" name="offers" [(ngModel)]="whichOffer" (keydown)="search()" (keyup)="search()" (blur)="search()" placeholder="{{ 'Offers.Search' | translate }} {{ ('Standard.Documents' | translate ) | lowercase }}" />
            <button class="btn btn-success col-2 ml-1" (click)="search()">{{ 'Offers.Search' | translate }}</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <table class="table table-striped table-sm" aria-label="Searched offers table">
              <tr>
                <th>{{ 'Standard.Number' | translate }}</th>
                <th>{{ 'Standard.Customer' | translate }}</th>
                <th>{{ 'Standard.Address' | translate }}</th>
                <th>{{ 'Standard.City' | translate }}</th>
                <th>{{ 'Standard.Title' | translate }}</th>
                <th>{{ 'Standard.Description' | translate }}</th>
                <th>{{ 'Standard.Responsible' | translate }}</th>
              </tr>
              <tr class="singleOffer" *ngFor="let x of output" (click)="chooseOffer(x);close()">
                <td>{{ x.offerNumber }}</td>
                <td>
                  <b *ngIf="x.customer && x.customer.name">{{ x.customer.name }}</b>
                </td>
                <td>
                  <div *ngIf="x.customer && x.customer.address">{{ x.customer.address }}</div>
                </td>
                <td>
                  <div *ngIf="x.customer">
                    {{ x.customer.zipCode}} {{ x.city}}
                  </div>
                </td>
                <td><b *ngIf="x.title && x.title != '-'">{{ (x.title.length > 100)? (x.title | slice:0:100) + '...':(x.title) }}</b></td>
                <td>
                  <div class="moreinfo">
                    <div *ngIf="x.description" [innerHTML]="(x.description.split('</p')[0]).slice(0,65)"></div>
                    <span *ngIf="!!x.description && x.description.length > 65" class="tooltiptext" [innerHTML]="(x.description.split('</p')[0])"></span>
                  </div>
                </td>
                <td>{{ x.responsible.name }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer p-3 text-right">
        <div class="col-3">
          <button type="button" class="btn btn-secondary" (click)="close()">{{ 'Buttons.Close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
